var taillightUx = angular.module('taillightUx', ["material.components.datepicker"]);

taillightUx.factory('tuxFabMenuEvents', function () {
    return {
        closed : 'TUX-FAB-MENU-CLOSED',
        shown: 'TUX-FAB-MENU-SHOWN'
    };
});
